import { extractFromProseMirrorDoc } from "@shared/lib/card-stack/extracted"
import { initialIdList } from "@shared/lib/card-stack/prose-mirror-utils"
import { cardStackDocFromLegacyCards } from "@shared/lib/card-stack/unified-migration"
import type {
  CardStackAttributes,
  LegacyCardStackAttributes,
  LessonCard,
  UnifiedCardStackAttributes,
} from "@shared/models/card-stack"
import type { Planbook } from "@shared/models/planbook"
import { objectId } from "@shared/util/object-id"

export function generateBlankTemplateAttributes(
  planbook: Planbook,
  title = "My new template"
): CardStackAttributes & {
  cards: Array<LessonCard>
} {
  const cards: LessonCard[] = [
    {
      id: objectId(),
      type: "card-standards",
      attributes: {
        position: 0,
        title: "Standards",
        standards: [],
        attachments: [],
        commentIds: [],
        comments: [],
        color: "yellow",
        isPublic: false,
        parentCardId: null,
      },
    },
  ]

  if (planbook.attributes.flags.unifiedLessons) {
    const proseMirrorDoc = cardStackDocFromLegacyCards(cards)
    const proseMirrorIds = initialIdList(proseMirrorDoc)
    return {
      title,
      color: null,
      schemaVersion: 2,
      usedAs: "lesson-template",
      version: 0,
      parentCardStack: null,
      versionNarrative: {},
      commentIds: [],
      _revision: 0,
      _revisedBySessionId: "system",
      proseMirror: {
        json: proseMirrorDoc.toJSON(),
        ids: proseMirrorIds.save(),
      },
      extracted: extractFromProseMirrorDoc(proseMirrorDoc),
      cards,
    } satisfies UnifiedCardStackAttributes
  } else {
    return {
      title,
      color: null,
      schemaVersion: 1,
      usedAs: "lesson-template",
      version: 0,
      parentCardStack: null,
      versionNarrative: {},
      commentIds: [],
      _revision: 0,
      _revisedBySessionId: "system",
      cards,
      proseMirror: null,
      extracted: null,
    } satisfies LegacyCardStackAttributes
  }
}
